import React, { useState, useRef, useEffect } from 'react';

// --- Başarı Modalı ---
const SuccessModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
        <div className="bg-[#1E293B] border border-slate-700 rounded-lg p-8 max-w-sm w-full shadow-2xl">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-900/30 mb-4">
                <svg className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Onaya Gönderildi!</h3>
            <p className="text-slate-400 mb-6">Blog yazınız başarıyla kaydedildi ve editör onayına sunuldu. Onaylandıktan sonra yayına alınacaktır.</p>
            <button onClick={onClose} className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded transition-colors">Tamam</button>
          </div>
        </div>
      </div>
    );
};

const BlogEditorPage = () => {
  // Not: Gerçek uygulamada kullanıcı bilgisini decoded token'dan veya Context'ten almalısınız.
  // Şimdilik görsel amaçlı email'i tutuyoruz.
  const [currentUser] = useState({ email: 'admin@mekanname.com' }); 
  const fileInputRef = useRef(null);

  const initialFormState = {
    title: '',
    read_time: '',
    image_url: '', 
    content: ''
  };

  const [formData, setFormData] = useState(initialFormState);
  const [loading, setLoading] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL; 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getImageUrl = (path) => {
    if (!path) return '';
    if (path.startsWith('http') || path.startsWith('blob:')) return path;
    const baseUrl = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${baseUrl}${cleanPath}`;
  };

  // --- Görsel Yükleme ---
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadingImage(true);
    const formDataImage = new FormData();
    formDataImage.append('file', file);

    const token = localStorage.getItem('token'); 

    try {
        const response = await fetch(`${API_URL}/editor/blog-upload-image`, { 
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}` 
            },
            body: formDataImage,
        });

        if (response.ok) {
            const data = await response.json();
            setFormData(prev => ({ ...prev, image_url: data.url }));
        } else {
            console.error("Upload Hatası:", response.status);
            alert("Görsel yüklenirken bir hata oluştu. Oturumunuzu kontrol edin.");
        }
    } catch (error) {
        console.error("Upload Error:", error);
    } finally {
        setUploadingImage(false);
    }
  };

  // --- Form Gönderme (Onaya Sunma) ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Token kontrolü: Kayıt eden kişinin (creator_id) belirlenmesi için şart.
    const token = localStorage.getItem('token');
    if (!token) {
        alert("Oturum süreniz dolmuş veya giriş yapmamışsınız. Lütfen tekrar giriş yapın.");
        return;
    }

    if (!formData.image_url) {
        alert("Lütfen bir kapak görseli yükleyiniz.");
        return;
    }

    setLoading(true);
    
    // Backend'e gönderilecek veri paketi
    // Backend token'dan user_id'yi alıp 'creator_id' sütununa yazacak.
    const submissionData = {
        ...formData,
        status: 1, // Onay bekliyor
        // creator_id: Frontend'den manuel gönderilmez, Token'dan alınır.
    };
    
    try {
      const response = await fetch(`${API_URL}/create-blog`, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` // KRİTİK DEĞİŞİKLİK: Token eklendi.
        },
        body: JSON.stringify(submissionData)
      });
      
      if (response.ok) {
          setTimeout(() => {
            setLoading(false);
            setShowModal(true); // Başarı modalını aç
            setFormData(initialFormState); // Formu temizle
          }, 500);
      } else {
          // Hata durumunda backend'den gelen mesajı okumaya çalışalım
          const errorData = await response.json().catch(() => ({ detail: 'Bilinmeyen hata' }));
          throw new Error(errorData.detail || 'Kaydetme başarısız');
      }

    } catch (error) {
      console.error('Hata:', error);
      alert(`Blog gönderilirken bir hata oluştu: ${error.message}`);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] text-slate-300 p-8 font-sans relative">
      <SuccessModal isOpen={showModal} onClose={() => setShowModal(false)} />

      {/* Header */}
      <div className="flex justify-between items-center mb-6 border-b border-slate-700 pb-4">
         <div>
            <h1 className="text-2xl font-bold text-[#60A5FA]">Editör Blog Oluşturucu</h1>
            <p className="text-xs text-slate-500 mt-1">Oluşturduğunuz içerikler yönetici onayından geçecektir.</p>
         </div>
      </div>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        
        {/* SOL KOLON: Meta Bilgiler */}
        <div className="lg:col-span-1 space-y-6">
          <div className="bg-[#1E293B] rounded-lg border border-slate-700 p-6 shadow-lg">
            
            <div className="text-[#2DD4BF] font-semibold border-b border-slate-700 pb-2 mb-6">
              Genel Blog Bilgileri
            </div>

            <div className="space-y-4">
              <div>
                <label className="text-sm text-slate-400">Blog Başlığı</label>
                <input
                  type="text" name="title" value={formData.title} onChange={handleChange} required
                  className="w-full bg-[#0F172A] border border-slate-600 rounded-md p-3 text-white mt-1 focus:border-blue-500 outline-none transition-colors"
                />
              </div>

              <div>
                <label className="text-sm text-slate-400">Okuma Süresi (örn: 5 dk)</label>
                <input
                  type="text" name="read_time" value={formData.read_time} onChange={handleChange}
                  className="w-full bg-[#0F172A] border border-slate-600 rounded-md p-3 text-white mt-1 focus:border-blue-500 outline-none transition-colors"
                />
              </div>

              <div>
                <label className="text-sm text-slate-400">Yazar (Otomatik)</label>
                <input
                  type="text" value={currentUser.email} readOnly disabled
                  className="w-full bg-[#0F172A] border border-slate-700 rounded-md p-3 text-slate-500 mt-1 cursor-not-allowed italic"
                  title="Yazar bilgisi giriş yaptığınız hesaptan (Token) otomatik alınır."
                />
              </div>

              {/* Görsel Yükleme Alanı */}
              <div className="pt-2">
                <label className="text-sm text-slate-400 mb-2 block">Kapak Görseli</label>
                <input 
                    type="file" 
                    ref={fileInputRef} 
                    onChange={handleImageUpload} 
                    accept="image/*"
                    className="hidden" 
                />

                <div className="bg-[#0F172A] border border-slate-600 border-dashed rounded-md p-4 flex flex-col items-center justify-center min-h-[150px] relative overflow-hidden group">
                  {formData.image_url ? (
                    <>
                        <img 
                            src={getImageUrl(formData.image_url)} 
                            alt="Kapak" 
                            className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-40 transition-opacity"
                        />
                        <button 
                            type="button"
                            onClick={() => fileInputRef.current.click()}
                            className="relative z-10 bg-black/60 hover:bg-black/80 text-white text-xs px-3 py-1 rounded backdrop-blur-sm transition-colors"
                        >
                            Görseli Değiştir
                        </button>
                    </>
                  ) : (
                    <>
                        {uploadingImage ? (
                            <span className="text-blue-400 text-sm animate-pulse">Yükleniyor...</span>
                        ) : (
                            <>
                                <p className="text-xs text-slate-500 mb-3 text-center">Dosyayı sürükleyin veya seçin</p>
                                <button 
                                    type="button" 
                                    onClick={() => fileInputRef.current.click()}
                                    className="bg-[#2563EB] hover:bg-blue-600 text-white text-sm font-semibold py-2 px-4 rounded transition-colors"
                                >
                                    DOSYA SEÇ
                                </button>
                            </>
                        )}
                    </>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* SAĞ KOLON: İçerik */}
        <div className="lg:col-span-2">
           <div className="bg-[#1E293B] rounded-lg border border-slate-700 p-6 shadow-lg h-full flex flex-col">
              <div className="text-[#2DD4BF] font-semibold border-b border-slate-700 pb-2 mb-4">Blog İçeriği</div>
              <textarea
                 name="content" value={formData.content} onChange={handleChange}
                 className="flex-grow w-full bg-[#0F172A] border border-slate-600 rounded-md p-4 text-white resize-none min-h-[400px] focus:border-blue-500 outline-none transition-colors"
                 placeholder="İçeriğinizi buraya yazın..."
              ></textarea>
              
              <div className="mt-4 flex justify-end items-center gap-4">
                <span className="text-xs text-slate-500 italic">
                    *İçerik gönderildikten sonra yönetici onayına düşecektir.
                </span>
                <button 
                  type="submit" disabled={loading}
                  className={`
                    ${loading ? 'bg-gray-600 cursor-not-allowed' : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:scale-105'}
                    text-white font-bold py-3 px-8 rounded shadow-lg transition-all duration-200
                  `}
                >
                  {loading ? 'GÖNDERİLİYOR...' : 'ONAYA GÖNDER'}
                </button>
              </div>
           </div>
        </div>

      </form>
    </div>
  );
};

export default BlogEditorPage;